import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & { size?: number };

const Stroke: React.FC<IconProps> = ({ size = 18, children, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {children}
  </svg>
);

const Fill: React.FC<IconProps> = ({ size = 18, children, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...rest}>
    {children}
  </svg>
);

export const LinkedInIcon: React.FC<IconProps> = props => (
  <Fill {...props}>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.125 2.062 2.062 0 0 1 0 4.125zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </Fill>
);

export const GitHubIcon: React.FC<IconProps> = props => (
  <Fill {...props}>
    <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.51 11.51 0 0 1 12 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
  </Fill>
);

export const MediumIcon: React.FC<IconProps> = props => (
  <Fill {...props}>
    <path d="M13.54 12a6.8 6.8 0 0 1-6.77 6.82A6.8 6.8 0 0 1 0 12a6.8 6.8 0 0 1 6.77-6.82A6.8 6.8 0 0 1 13.54 12zm7.42 0c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z" />
  </Fill>
);

export const MailIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <rect x="2" y="4" width="20" height="16" rx="3" />
    <path d="m22 7-10 6L2 7" />
  </Stroke>
);

export const PinIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
    <circle cx="12" cy="10" r="3" />
  </Stroke>
);

export const ArrowRightIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="M5 12h14M13 5l7 7-7 7" />
  </Stroke>
);

export const ArrowUpIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="M12 19V5M5 12l7-7 7 7" />
  </Stroke>
);

export const ExternalIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="M7 17 17 7M8 7h9v9" />
  </Stroke>
);

export const PlayIcon: React.FC<IconProps> = props => (
  <Fill {...props}>
    <path d="M7 4.5v15a1 1 0 0 0 1.53.85l12-7.5a1 1 0 0 0 0-1.7l-12-7.5A1 1 0 0 0 7 4.5z" />
  </Fill>
);

export const StopIcon: React.FC<IconProps> = props => (
  <Fill {...props}>
    <rect x="5" y="5" width="14" height="14" rx="2.5" />
  </Fill>
);

export const FolderIcon: React.FC<IconProps> = props => (
  <Fill {...props}>
    <path d="M3 6.5A2.5 2.5 0 0 1 5.5 4h3.59a2 2 0 0 1 1.41.59L12 6h6.5A2.5 2.5 0 0 1 21 8.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 17.5v-11z" />
  </Fill>
);

export const ChevronIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="m9 6 6 6-6 6" />
  </Stroke>
);

export const CheckIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="M20 6 9 17l-5-5" />
  </Stroke>
);

export const SearchIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </Stroke>
);

export const SunIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </Stroke>
);

export const MoonIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </Stroke>
);

export const MonitorIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <path d="M8 21h8M12 17v4" />
  </Stroke>
);

export const HomeIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <rect x="4" y="4" width="16" height="16" rx="5" />
  </Stroke>
);

export const CameraIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
    <circle cx="12" cy="13.5" r="3.5" />
  </Stroke>
);

export const PhoneIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <rect x="6" y="2" width="12" height="20" rx="3" />
    <path d="M10.5 5h3" />
  </Stroke>
);

export const HammerIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="m15 12-8.5 8.5a2.12 2.12 0 0 1-3-3L12 9" />
    <path d="M17.64 15 22 10.64M20.91 11.7l-1.25-1.25a2.4 2.4 0 0 1-.7-1.7V7.86L16.2 5.1a5.56 5.56 0 0 0-3.94-1.64H9l.92.82A6.18 6.18 0 0 1 12 8.4v1.56l2 2h2.47a2.4 2.4 0 0 1 1.7.7l1.25 1.25" />
  </Stroke>
);

export const SwiftFileIcon: React.FC<IconProps> = ({ size = 14, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" {...rest}>
    <rect x="2" y="2" width="20" height="20" rx="5" fill="#F05138" />
    <path
      fill="#fff"
      d="M15.9 16.8c-2.1 1.2-5 1.3-7.9.1-2.3-1-4.2-2.7-5.4-4.6.6.5 1.3.9 2 1.2 3 1.4 6 1.3 8.1 0-3-2.3-5.5-5.3-7.4-7.7-.4-.4-.7-.9-1-1.4 2.3 2.1 5.9 4.7 7.2 5.4-2.7-2.9-5.1-6.4-5-6.3 4.3 4.3 8.3 6.8 8.3 6.8.1.1.2.1.3.2.1-.2.2-.5.2-.8.7-2.5-.1-5.4-1.8-7.8 4 2.4 6.3 6.9 5.4 10.7 0 .1 0 .2-.1.3 2 2.5 1.5 5.1 1.2 4.6-1-2.1-3-1.5-3.3-1.2z"
    />
  </svg>
);

export const SignalIcon: React.FC<IconProps> = ({ size = 18, ...rest }) => (
  <svg width={size} height={size * 0.66} viewBox="0 0 18 12" fill="currentColor" aria-hidden="true" {...rest}>
    <rect x="0" y="8" width="3" height="4" rx="1" />
    <rect x="5" y="5.5" width="3" height="6.5" rx="1" />
    <rect x="10" y="3" width="3" height="9" rx="1" />
    <rect x="15" y="0" width="3" height="12" rx="1" />
  </svg>
);

export const WifiIcon: React.FC<IconProps> = ({ size = 16, ...rest }) => (
  <svg width={size} height={size * 0.72} viewBox="0 0 16 11.5" fill="currentColor" aria-hidden="true" {...rest}>
    <path d="M8 2.2c2.3 0 4.4.9 6 2.4l1.1-1.1A10 10 0 0 0 8 .6 10 10 0 0 0 .9 3.5L2 4.6a8.4 8.4 0 0 1 6-2.4zm0 3.3c1.4 0 2.7.5 3.7 1.4l1.1-1.1A7 7 0 0 0 8 3.9a7 7 0 0 0-4.8 1.9l1.1 1.1c1-.9 2.3-1.4 3.7-1.4zm0 3.2c.6 0 1.1.2 1.5.6L8 10.8 6.5 9.3c.4-.4.9-.6 1.5-.6z" />
  </svg>
);

export const BatteryIcon: React.FC<IconProps> = ({ size = 26, ...rest }) => (
  <svg width={size} height={size * 0.48} viewBox="0 0 27 13" aria-hidden="true" {...rest}>
    <rect x="0.5" y="0.5" width="23" height="12" rx="3.8" fill="none" stroke="currentColor" strokeOpacity="0.4" />
    <rect x="2" y="2" width="20" height="9" rx="2.4" fill="currentColor" />
    <path d="M25 4.5v4c.8-.3 1.4-1.1 1.4-2s-.6-1.7-1.4-2z" fill="currentColor" fillOpacity="0.4" />
  </svg>
);

export const MenuIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="M4 7h16M4 12h16M4 17h10" />
  </Stroke>
);

export const CloseIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <path d="M18 6 6 18M6 6l12 12" />
  </Stroke>
);

export const GlobeIcon: React.FC<IconProps> = props => (
  <Stroke {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
  </Stroke>
);

export const SendIcon: React.FC<IconProps> = props => (
  <Stroke {...props} strokeWidth={2.4}>
    <path d="M12 19V5M5.5 11.5 12 5l6.5 6.5" />
  </Stroke>
);
